export class StringLiterals {
    static interceptorBypassHeaderKey = 'interceptor-bypass';
    static interceptorDownloadHeaderKey = 'download-request';
    static favBox = '1px solid #666'
    static favBoxTop = 'none'
    static favPadding = '20px'
}